import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type DocumentSkeltonProp = {
  className: string;
};

export const DocumentSkelton = ({ className }: DocumentSkeltonProp) => {
  const List = Array.from({ length: 2 }, (_, i) => i + 1);
  const ChildList = Array.from({ length: 5 }, (_, i) => i + 1);

  return (
    <Card className={cn("flex p-5 gap-10", className)}>
      <div className="w-[50%] ">
        <Skeleton className="h-full bg-gray-300 rounded-bl-none rounded-br-none" />
      </div>
      <div className="w-[50%]">
        <div className="px-2 py-3 space-y-5">
          {List.map((_, index) => {
            return (
              <div key={index} className="flex flex-col gap-4">
                <Skeleton className="h-[40px]  bg-gray-300" />
                {ChildList.map((_, childIndex) => {
                  return (
                    <Skeleton
                      key={childIndex}
                      className="h-[20px] bg-gray-300"
                    />
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
};
